import React from 'react'

function WarningContainer({ children }) {
    const styles = {
        warningContainer: {
            display: "flex",
            alignItems: "center",
            color: "#09090b",
            fontSize: "14px",
            border: "1px solid #bfdbfe",
            borderRadius: "6px",
            padding: "16px",
            marginTop: "24px",
            backgroundColor: "var(--mainColor-light)"
        }
    };
    return (
        <div style={styles.warningContainer}>
            {children}
        </div>
    )
}

export default WarningContainer